<ng-content></ng-content>
<div class="flex flex-col gap-4 pt-2">

  <!-- Upload area -->
  <div *ngIf="file_upload_mode">
    <label for="fileInput"
      class="flex flex-col items-center justify-center w-full py-6 dashed-border rounded-2xl cursor-pointer bg-white transition"
      [ngClass]="{
        'dashed-border-active bg-blue-50': is_dragging && !is_uploading,
        'pointer-events-none opacity-50': error_message || is_uploading
      }"
      (dragover)="on_drag_over($event)" (dragleave)="on_drag_leave($event)" (drop)="on_drop($event)">

      <div class="flex flex-col items-center gap-3">
        <img src="../../../assets/file-uplod-bulk.png" alt="" class="w-14 h-14 opacity-60">
        <p class="text-[16px] text-[#333333]">
          Drag and drop a file or <span class="underline cursor-pointer font-medium">browse file</span>
        </p>
        <p class="text-[14px] italic text-[#888888]">(Supported Only .CSV File)</p>
        <p class="text-[14px] font-semibold text-[#888888] tracking-widest">OR</p>
        <button type="button" (click)="download_template(); $event.preventDefault()"
          class="text-[14px] font-semibold text-primary underline">Download Template</button>
      </div>

      <input id="fileInput" type="file" class="hidden" [accept]="accepted_type" (change)="on_file_change($event)" />
    </label>
  </div>

  <!-- Error message -->
  <div *ngIf="error_message" class="text-red-600 whitespace-pre-line text-sm">{{ error_message }}</div>

  <!-- Preview table -->
  <div *ngIf="!file_upload_mode && enable_preview && display_data.length > 0"
    class="bg-white border border-primary rounded-lg overflow-x-auto max-h-[400px] overflow-y-auto">
    <table class="table-auto w-full border-collapse text-sm">
      <thead class="font-medium text-primary border-b border-[#CFD5F1]">
        <tr>
          <th *ngFor="let key of display_data[0] | keyValueWithOrder" class="px-4 h-11 text-center truncate">{{ key.key }}</th>
        </tr>
      </thead>
      <tbody class="text-black/80">
        <tr *ngFor="let row of display_data; let i = index" class="border-b border-[#CFD5F1]">
          <td *ngFor="let key of row | keyValueWithOrder" class="px-4 h-11 text-center truncate">{{ row[key.key] }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Error report -->
  <div *ngIf="!file_upload_mode && error_report.length > 0" class="flex flex-col gap-1 max-h-[200px] overflow-y-auto">
    <ng-container *ngFor="let errs of error_report; let i = index">
      <div *ngFor="let err of errs" class="text-red-600 text-sm bg-red-50 border border-red-200 rounded px-3 py-1">
        <span class="font-medium">Row {{ i + 1 }}: </span>{{ err }}
      </div>
    </ng-container>
  </div>

  <!-- Actions -->
  <div class="flex items-center gap-3 mt-1" [ngClass]="!file_upload_mode ? 'justify-between' : 'justify-end'">
    <button *ngIf="!file_upload_mode || error_message"
      class="border border-gray-300 text-gray-600 font-medium rounded-full text-sm px-6 h-10 hover:bg-gray-50 transition"
      (click)="reupload()">Reupload</button>
    <div class="flex gap-3">
      <button type="button" (click)="cancel.close()"
        class="border border-gray-300 text-gray-700 font-semibold rounded-full text-sm px-6 h-10 hover:bg-gray-50 transition">
        Discard
      </button>
      <button type="button" (click)="on_submit()"
        [disabled]="error_message !== '' || display_data.length == 0 || disabled"
        class="rounded-full text-sm px-6 h-10 font-semibold transition flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
        [ngClass]="(error_message !== '' || display_data.length == 0 || disabled) ? 'bg-gray-200 text-gray-500' : 'bg-primary text-white'">
        <span>+</span> {{ button_title || 'Add' }}
      </button>
    </div>
  </div>

</div>